<template>
    <transition name="fade">
        <div @mouseover="accelerateVideo" @mouseout="decelerateVideo" id="accelerate-button">
        </div>
    </transition>
</template>
<script>
    export default {
        name: 'AccelerateButton',
        methods: {
            accelerateVideo() {
                // let video = this.$parent.video;
                // if (video.playbackRate >= 2) {
                //     window.clearInterval(intervalFast)
                // } else {
                //     let intervalFast = window.setInterval(() => {
                //         video.playbackRate = video.playbackRate + 0.1
                //         this.test = video.playbackRate
                //     }, 250);
                // }
                this.$parent.video.playbackRate = 2
            },
            decelerateVideo() {
                // let video = this.$parent.video;
                // if (video.playbackRate <= 1) {
                //     window.clearInterval(intervalSlow)
                // } else {
                //     let intervalSlow = window.setInterval(() => {
                //         video.playbackRate = video.playbackRate - 0.1
                //         this.test = video.playbackRate
                //     }, 1000);
                // }
                this.$parent.video.playbackRate = 1

            }
        }
    }
</script>
<style scoped lang="scss">
    #accelerate-button {
        background-color: transparent;
        border: 3px dashed #b71540;
        position: absolute;
        bottom: 10%;
        right: 10%;
        width: 20%;
        height: 20%;
        cursor: pointer;
    }
</style>